export default "__VITE_ASSET__aKx7$PQl__"